export default function Maintenance() {
  return (
    <div
      data-testid="maintenance-page"
      className="min-h-screen flex flex-col items-center justify-center bg-[#0C0C0A] px-6 text-center"
    >
      <div className="overline mb-6 text-[#D4AF37] tracking-[0.35em] uppercase text-xs">
        Maison Afra
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F5F5F0] leading-tight mb-6">
        Site en maintenance
      </h1>
      <div className="w-16 h-px bg-[#D4AF37] mb-6" />
      <p className="text-[#A3A39D] text-base max-w-md mb-2">
        Nous préparons quelque chose d'exceptionnel. Notre boutique revient très bientôt.
      </p>
      <p className="text-[#6B6B64] text-sm max-w-md">
        Our site is currently under maintenance. We will be back shortly.
      </p>
      <a
        href="mailto:info@maisonafra.fr"
        data-testid="maintenance-contact-link"
        className="mt-10 text-sm text-[#D4AF37] border border-[#D4AF37]/40 px-6 py-3 hover:bg-[#D4AF37]/10 transition-colors"
      >
        info@maisonafra.fr
      </a>
    </div>
  );
}
